module.exports = __webpack_public_path__ + "media/icons-for-sprite/settings--black-86abcaed.svg";